import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import * as Sentry from "@sentry/react";
import { I18nextProvider } from "react-i18next";
import i18n, { initClientI18n } from "~/i18n";
import { useLocaleStore } from "~/stores/locale";
import { localeFromPathname } from "~/lib/locales";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

// Sync locale store → i18next on client-side navigation.
// locale-layout.tsx sets the store; this subscription calls changeLanguage.
useLocaleStore.subscribe((state) => {
  if (i18n.language !== state.locale) {
    i18n.changeLanguage(state.locale);
  }
});

function getLocaleFromPath(): string {
  return localeFromPathname(window.location.pathname);
}

function ClientApp() {
  return (
    <I18nextProvider i18n={i18n}>
      <HydratedRouter />
    </I18nextProvider>
  );
}

// Initialize i18n with the correct locale before hydrating so the client
// tree matches the SSR-rendered HTML and avoids a translation flash.
initClientI18n(getLocaleFromPath()).then(() => {
  startTransition(() => {
    hydrateRoot(document, <StrictMode><ClientApp /></StrictMode>);
  });
});
